








import {
    Component,
    Prop,
    Vue,
    Watch,
    Mixins,
    Emit,
} from 'vue-property-decorator';

@Component({
    components: {}
})
export default class RadialChart extends Vue {

    /**
     * Chart data
     */
    @Prop({ type: Array, default: ()=>([]) })
    public chartData!: any[];

    /**
     * Chart data
     */
    @Prop({ type: Array, default: ()=>([]) })
    public labels!: any[];

    /**
     * Reset chart
     */
    @Prop({ type: Boolean, default: false })
    public resetChart!: boolean;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: String, default: 'Factor' })
    public name!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: String, default: 'bar' })
    public chartType!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Object, default: () => ({}) })
    public chartOptions!: any;
    
    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 600})
    public height!: number;
    
    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 600})
    public width!: number;

     /**
     * Chart options(If override default options)
     */
    @Prop({ type: String, default: '%'})
    public scoringSuffix!: string;
    
    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 100})
    public maxScoringRange!: number;

    /**
     * ApexCharts data
     */
    private options: any = {};
    private series: any[] = [];


    /**
     * initialize
     */
    mounted() {
        console.log('mounted()');
        console.log(this.labels);
        console.log(this.chartData);
    }


    /**
     * Watching for changes to the chartData property
     */
    @Watch('chartData', {deep: true, immediate: true})
    onChangeChartData() {
        if (!Object.keys(this.chartOptions).length) {
            this.options = this.applyDefaultOptions();
        } else {
            this.options = this.chartOptions;
        }
        this.series = this.chartData;
        console.log('onChangeChartData()');
        console.log(this.series);
        console.log(this.options);
    }


    /**
     * Default Options
     */
    private applyDefaultOptions() {
        return {
            chart: {
                height: this.height,
                width: this.width,
                type: this.chartType,
            },
            plotOptions: {
                bar: {
                    horizontal:true,
                    dataLabels: {
                        position: 'center', // top, center, bottom
                    },
                    // endingShape: 'round', // flat, rounded // deprecated
                    columnWidth: '100%',
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val: any) {
                    return String(val ? val.toFixed(1) : '');
                },
                offsetY: 0,
                style: {
                    fontSize: '16px',
                    colors: ["#ffffff"]
                }
            },
            
            xaxis: {
                min: 0,
                max: this.maxScoringRange,
                categories: this.labels,
                position: 'bottom',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                    type: 'gradient',
                    gradient: {
                        colorFrom: '#D8E3F0',
                        colorTo: '#BED1E6',
                        stops: [0, 100],
                        opacityFrom: 0.4,
                        opacityTo: 0.5,
                    }
                    }
                },
                tooltip: {
                    enabled: false,
                }
            },
            yaxis: {
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true
                },
                labels: {
                    show: true,
                }
            },
            title: {
                text: this.name,
                floating: true,
                offsetY: 0,
                align: 'center',
                style: {
                    color: '#444'
                }
            },
            grid: {
                show: true,
                borderColor: '#90A4AE',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: false
                    }
                },  
                row: {
                    colors: undefined,
                    opacity: 0.5
                },  
                column: {
                    colors: undefined,
                    opacity: 0.5
                },  
                padding: {
                    top: 16,
                    right: 0,
                    bottom: 16,
                    left: 0
                },  
            },
        }
    }

    /**
     * onClick
     */
    private onClick(event?: MouseEvent | undefined, activeElements?: {}[] | undefined): any {
    }

    /**
     * Reset chart position
     */
    @Watch('')
    private resetChartPosition() {
    }

    /**
     * click a chart element
     */
    @Emit('click-chart-element')
    public clickChartElement(element: any) {
        return element;
    }

}

